<template>
    <div class="card shadow h-100 py-2" :class="color">
        <div class="card-body">
            <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                    <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ nameCard }}</div>
                    <div class="h5 mb-0 font-weight-bold text-gray-800">{{ number }}</div>
                </div>
                <div class="col-auto">
                    <i class="fas fa-2x text-gray-300" :class="icon"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        nameCard: String,
        number: String,
        color: String
    }
}
</script>

<style></style>